export {downloadUrl, repoUrlPart} from './downloadUrl';



// WEBPACK FOOTER //
// ./src/helpers/index.js